import { withQuery } from '../utils/queryString'
import { idParaRuta } from '../utils/idParaRuta'
import { CALL_API } from '../middleware/api'

export const TICKET_LIST_REQUEST = 'TICKET_LIST_REQUEST'
export const TICKET_LIST_SUCCESS = 'TICKET_LIST_SUCCESS'
export const TICKET_LIST_FAILURE = 'TICKET_LIST_FAILURE'

export const TICKET_DETAIL_REQUEST = 'TICKET_DETAIL_REQUEST'
export const TICKET_DETAIL_SUCCESS = 'TICKET_DETAIL_SUCCESS'
export const TICKET_DETAIL_FAILURE = 'TICKET_DETAIL_FAILURE'

export const TICKET_CREATE_REQUEST = 'TICKET_CREATE_REQUEST'
export const TICKET_CREATE_SUCCESS = 'TICKET_CREATE_SUCCESS'
export const TICKET_CREATE_FAILURE = 'TICKET_CREATE_FAILURE'

export const TICKET_ACTION_REQUEST = 'TICKET_ACTION_REQUEST'
export const TICKET_ACTION_SUCCESS = 'TICKET_ACTION_SUCCESS'
export const TICKET_ACTION_FAILURE = 'TICKET_ACTION_FAILURE'

export const UPDATE_TICKET_FILTERS = 'UPDATE_TICKET_FILTERS'

export function updateTicketFilters(filters) {
  return {
    type: UPDATE_TICKET_FILTERS,
    payload: filters
  }
}

/**
 * Un filtro sin valor no es un filtro: enviarlo (`status=`) es pedirle a la
 * API los casos cuyo estado está vacío, que no es lo que quiere quien acaba
 * de limpiar el filtro.
 */
export const filtrosConValor = (params = {}) =>
  Object.keys(params).reduce((limpios, clave) => {
    const valor = params[clave]
    const vacio =
      valor === '' ||
      valor === null ||
      valor === undefined ||
      (Array.isArray(valor) && valor.length === 0)
    if (!vacio) limpios[clave] = valor
    return limpios
  }, {})

export function ticketList(params = {}) {
  const filtros = filtrosConValor(params)

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: withQuery('ticketing/tickets/', filtros),
      authenticated: true,
      extra: filtros,
      // Escribir en el buscador encadena peticiones: la última manda.
      msg: 'ticketList',
      types: [TICKET_LIST_REQUEST, TICKET_LIST_SUCCESS, TICKET_LIST_FAILURE]
    }
  }
}

export function ticketDetail(id) {
  return {
    [CALL_API]: {
      method: 'GET',
      endpoint: `ticketing/tickets/${idParaRuta(id, 'ticketDetail')}/`,
      authenticated: true,
      types: [
        TICKET_DETAIL_REQUEST,
        TICKET_DETAIL_SUCCESS,
        TICKET_DETAIL_FAILURE
      ]
    }
  }
}

export function createTicket(data) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'ticketing/tickets/',
      data,
      authenticated: true,
      types: [
        TICKET_CREATE_REQUEST,
        TICKET_CREATE_SUCCESS,
        TICKET_CREATE_FAILURE
      ]
    }
  }
}

export function changeTicketStatus(id, { status, comment = '' }) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `ticketing/tickets/${id}/change-status/`,
      data: { status, comment },
      authenticated: true,
      types: [
        TICKET_ACTION_REQUEST,
        TICKET_ACTION_SUCCESS,
        TICKET_ACTION_FAILURE
      ]
    }
  }
}

export function assignTicket(id, { administrator_id, comment = '' }) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `ticketing/tickets/${id}/assign/`,
      data: { administrator_id, comment },
      authenticated: true,
      types: [
        TICKET_ACTION_REQUEST,
        TICKET_ACTION_SUCCESS,
        TICKET_ACTION_FAILURE
      ]
    }
  }
}

export function linkGitLabIssue(
  id,
  { issue_iid, issue_url = '', project_id = null }
) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `ticketing/tickets/${id}/link-gitlab/`,
      data: { issue_iid, issue_url, project_id },
      authenticated: true,
      types: [
        TICKET_ACTION_REQUEST,
        TICKET_ACTION_SUCCESS,
        TICKET_ACTION_FAILURE
      ]
    }
  }
}

export function addTicketComment(id, { message, is_internal = true }) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `ticketing/tickets/${id}/add-comment/`,
      data: { message, is_internal },
      authenticated: true,
      types: [
        TICKET_ACTION_REQUEST,
        TICKET_ACTION_SUCCESS,
        TICKET_ACTION_FAILURE
      ]
    }
  }
}

export function answerClaim(id, { provider_response }) {
  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: `ticketing/tickets/${id}/answer-claim/`,
      data: { provider_response },
      authenticated: true,
      types: [
        TICKET_ACTION_REQUEST,
        TICKET_ACTION_SUCCESS,
        TICKET_ACTION_FAILURE
      ]
    }
  }
}
